export default function accessImage(filename) {
    return `https://images.binviewer.com/${filename.substring(13)}`;
}
